export default __webpack_public_path__ + "static/program-circle-revived-en-6cde56c5dbf4c5cc6e004dd72f0fa24a.svg";